export const FETCH_AUTH_USER = "FETCH_AUTH_USER";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const CLEAR_AUTH_USER = "CLEAR_AUTH_USER";
export const AUTH_USER_ERROR = "AUTH_USER_ERROR";
export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL";
export const SET_AUTH_FETCH = "SET_AUTH_FETCH";
